export const translate = {};